import { useState } from 'react';

import { useNotificationContext } from '../context/NotificationContext';
import { NotificationTableFooterProps } from '../types/notificationTypes';
import { NotificationPagination } from './NotificationPagination';

export const NotificationTableFooter = ({
  linePerPage,
  totalData
}: NotificationTableFooterProps) => {
  const { currentPage, setCurrentPage, itemsPerPage, setItemsPerPage } =
    useNotificationContext();

  const [limitValue, setLimitValue] = useState(itemsPerPage);

  return (
    <>
      <hr className="tw-mt-5" />
      <footer className="tw-py-6 tw-px-5 md:tw-flex tw-justify-between tw-text-[#5A5A5A]">
        <div className="tw-mb-3 tw-flex tw-gap-5 tw-items-center">
          <p>Linhas por página</p>
          <select
            className="tw-py-2 tw-px-3 tw-focus:outline-none tw-focus:ring-0 tw-border tw-border-[#ECE6F0] tw-rounded-md"
            value={limitValue}
            onChange={(e) => {
              const limitSelected = e.target.value;
              const limitNumber = Number(limitSelected);
              setLimitValue(limitNumber);
              setItemsPerPage(limitNumber);
              setCurrentPage(1);
            }}
          >
            {linePerPage.map((opt, index) => {
              return (
                <option key={index} value={opt}>
                  {opt}
                </option>
              );
            })}
          </select>
        </div>
        <NotificationPagination
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
          itemsPerPage={itemsPerPage}
          totalItems={totalData}
        />
      </footer>
    </>
  );
};
